// Assuming `image` is the URL created with URL.createObjectURL(file)
export const createBlobFromImageUrl = async (imageURL: string) => {
  try {
    const response = await fetch(imageURL);
    if (!response.ok) {
      throw new Error('Failed to fetch images');
    }
    return await response.blob();
  } catch (error) {}
};
